import * as React from "react";
import { useReveal } from "../../hooks";

type Props = React.PropsWithChildren<{
  id: string;
  index?: string;
  title: string;
  lede?: string;
  className?: string;
  /** Suppress the top hairline where two sections would double up. */
  seamless?: boolean;
}>;

export default function Section({
  id,
  index,
  title,
  lede,
  className = "",
  seamless,
  children,
}: Props) {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section
      id={id}
      className={`anchor-offset ${seamless ? "" : "hairline-t"} ${className}`}
    >
      <div className="shell py-16 md:py-24">
        <div ref={ref} className="reveal">
          <header className="max-w-2xl">
            <div className="flex items-center gap-3">
              {index && <span className="eyebrow">{index}</span>}
              <span className="eyebrow">{title}</span>
            </div>
            {lede && (
              <p className="mt-4 text-balance text-xl leading-snug tracking-tight text-ink md:text-2xl">
                {lede}
              </p>
            )}
          </header>
        </div>
        <div className="mt-10 md:mt-12">{children}</div>
      </div>
    </section>
  );
}

/** Wraps a block so it fades up when scrolled into view. */
export function Reveal({
  children,
  delay = 0,
  className = "",
}: React.PropsWithChildren<{ delay?: number; className?: string }>) {
  const ref = useReveal<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`reveal ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
